import axios from "axios";

const API = axios.create({
  baseURL: "https://insightly.novatech-solutions.se/api/",
});

// Add interceptor to include JWT token in headers
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
